export default __webpack_public_path__ + "static/media/lic4.7f8ca131.svg";